import DialogButton, { type DialogButtonTemplateParams } from 'Components/smallComponents/dialogButton';
import type { TemplateFunction, TemplateResult } from 'Components/types';

interface Props {
  closeGarage: () => void;
  template: TemplateFunction<DialogButtonTemplateParams>;
}

export default function AddButton({ closeGarage, template }: Props): TemplateResult {
  const props = { template, onClick: closeGarage, dialogName: 'VehicleWidgetDialog' };
  return <DialogButton {...props} />;
}
